var _linearGradient, _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 89.958 89.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 8.655,
    y1: 8.655,
    x2: 81.304,
    y2: 81.304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009fe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "#0096d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#137dc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#2469b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#2a59a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#2e4d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#304597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304296"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.979,
    cy: 44.979,
    r: 44.979,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    d: "M44.985 2.968l-.904 2.796h-2.983l2.432 1.809-.946 2.871 2.401-1.769 2.402 1.769-.936-2.871 2.412-1.809h-2.994l-.884-2.796zM27.709 6.638l.312 2.922-2.727 1.214 2.959.663.304 3.008 1.473-2.593 2.913.639-2.022-2.242 1.468-2.634-2.736 1.218-1.944-2.195zM13.419 17.018l1.473 2.543-1.996 2.217 2.971-.597 1.501 2.624.292-2.968 2.922-.601-2.76-1.226.27-3.003-2.004 2.225-2.669-1.214zM4.586 32.312l2.38 1.724-.922 2.839 2.472-1.755 2.439 1.787-.94-2.831 2.423-1.737-3.019.003-.976-2.854-.924 2.848-2.933-.024zM2.737 49.878l2.876.606.312 2.968 1.545-2.608 2.955.64-2.011-2.203 1.508-2.573-2.758 1.23-2.051-2.209.313 2.977-2.689 1.172zM8.193 66.676l2.874-.615 1.493 2.584.349-3.011 2.96-.616-2.732-1.196.331-2.964-2.019 2.246-2.773-1.185 1.497 2.593-1.98 2.164zM20.01 79.803l2.375-1.731 2.414 1.753-.904-2.892 2.453-1.767-2.983.02-.903-2.843-.931 2.872-3.014.046 2.421 1.76-.928 2.782zM36.145 86.988l1.465-2.547 2.918.621-2.003-2.275 1.523-2.612-2.716 1.231-1.981-2.23.317 3.003-2.735 1.267 2.927.623.285 2.919zM53.806 86.99l.303-2.923 2.918-.62-2.755-1.262.329-3.006-1.981 2.229-2.717-1.231 1.511 2.614-1.983 2.271 2.928-.623 1.447 2.551zM69.941 79.809l-.911-2.794 2.413-1.753-3.03-.033-.923-2.879-.902 2.841-2.983-.019 2.444 1.773-.889 2.881 2.423-1.76 2.358 1.743zM81.761 66.685l-1.969-2.182 1.492-2.583-2.782 1.202-2.014-2.254.331 2.963-2.732 1.195 2.954.626.359 2.994 1.498-2.593 2.863.632zM87.221 49.888l-2.686-1.192.313-2.967-2.053 2.23-2.757-1.24 1.508 2.572-2.01 2.203 2.953-.629 1.546 2.588.314-2.977 2.872-.588zM85.377 32.323l-2.939.004-.92-2.838-.969 2.872-3.023-.012 2.424 1.737-.94 2.83 2.442-1.776 2.465 1.735-.925-2.847 2.385-1.705zM76.548 17.026l-2.683 1.199-1.995-2.218.282 3.018-2.765 1.219 2.921.6.292 2.968 1.508-2.616 2.958.583-2.004-2.225 1.486-2.528zM62.261 6.644L60.298 8.83l-2.725-1.215 1.485 2.642-2.031 2.238 2.912-.639 1.475 2.592.315-3.003 2.939-.671-2.736-1.218.329-2.912z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.485 44.979c0-11.265 9.169-20.433 20.438-20.433h2.015v4.03h-2.015c-9.047 0-16.407 7.36-16.407 16.403 0 9.041 7.359 16.402 16.407 16.402h2.015v4.031h-2.015c-11.269 0-20.438-9.169-20.438-20.433zM44.614 44.979c0-11.265 9.173-20.433 20.44-20.433h2.016v4.03h-2.016c-8.006 0-14.969 5.974-16.195 13.894l-.076.497h13.045v4.024H48.783l.076.497c1.227 7.92 8.189 13.893 16.195 13.893h2.016v4.031h-2.016c-11.267 0-20.44-9.169-20.44-20.433z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCe);
export default __webpack_public_path__ + "static/media/ce.1dc0b8e14cb695701b79fc627a8706fd.svg";
export { ForwardRef as ReactComponent };